import React, { useEffect, useState } from 'react';
import { Users, Clock, Calendar, TrendingUp } from 'lucide-react';
import StatCard from './StatCard';
import { useApiHandler } from '../../../utils/apiHandler';

const DashboardStats = () => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiHandler = useApiHandler();

    useEffect(() => {
        const fetchTaskSummary = async () => {
            try {
                const response = await apiHandler.get('/employee/task-summary'); // Use the handler
                const data = response?.data?.data;

                // Map API data to the stats format
                const formattedStats = [
                    {
                        title: 'Total Tasks',
                        value: data.totalTasks || '0',
                        icon: Users, // Replace with an appropriate icon if needed
                        change: `${data.taskChange || '+0%'} change`,
                        color: 'blue',
                    },
                    {
                        title: 'Completed Tasks',
                        value: data.completedTasks || '0',
                        icon: Clock,
                        change: `${data.completedChange || '+0%'} completed`,
                        color: 'green',
                    },
                    {
                        title: 'Pending Tasks',
                        value: data.pendingTasks || '0',
                        icon: Calendar,
                        change: `${data.pendingChange || '+0%'} pending`,
                        color: 'purple',
                    },
                    {
                        title: 'Performance',
                        value: `${data.performance || '0'}%`,
                        icon: TrendingUp,
                        change: `${data.performanceChange || '+0%'} performance`,
                        color: 'orange',
                    },
                ];

                setStats(formattedStats);
                setLoading(false);
            } catch (err) {
                setError(err.message || 'Failed to fetch data');
                setLoading(false);
            }
        };

        fetchTaskSummary();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            {stats.map((stat, index) => (
                <StatCard key={index} {...stat} />
            ))}
        </div>
    );
};

export default DashboardStats;
